import { Wrapper, Search, Separator, Total, Showing } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useRouteStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function RoutesGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
    </Wrapper>}
    filters={null}
  />
}

export default function RoutesGridLayout() {
  return <GridProvider store={useRouteStore()}>
    <RoutesGrid />
  </GridProvider>
}
